import {addGroup, addGroupMember, removeGroup, removeGroupMember, updateGroup} from './groupActions'
import {Constants} from './groupConstants'
import {Group} from '../../../model/group.model'

type Actions =
	| ReturnType<typeof addGroup>
	| ReturnType<typeof updateGroup>
	| ReturnType<typeof removeGroup>
	| ReturnType<typeof addGroupMember>
	| ReturnType<typeof removeGroupMember>

export function groupReducer(
	state: Group[] = [],
	action: Actions
) {
	let groupWithMembers: Group | undefined

	switch (action.type) {

		case Constants.ADD_GROUP:
			return [...state, action.payload]

		case Constants.UPDATE_GROUP:
			return state.map((group) => {
				// if id does not match, return non changed item
				if (group.group_id !== action.payload.group_id) {
					return group
				}

				// replace with the updated item
				return {
					...group,
					...action.payload,
					...group.group_member,
					...action.payload.group_member
				}
			})
		case Constants.REMOVE_GROUP:
			return state.filter((group: Group) => group?.group_id !== action.payload)
		case Constants.ADD_GROUP_MEMBER:


			return state.map((group) => {
				if (group.group_id !== action.payload.groupId) {
					return group
				}
				
				let newGroupMember
				if (group.group_member) {
					newGroupMember = group.group_member?.concat(action.payload.groupMember)
				} else {
					newGroupMember = [action.payload.groupMember]
				}

				let groupCopy: Group = {...group}
				groupCopy.group_member = newGroupMember

				return {
					...groupCopy
				}

			})

		case Constants.REMOVE_GROUP_MEMBER:
			return state.map((group): Group => {
				// if id does not match, return non changed item
				if (group.group_id !== action.payload.groupId) {
					return group
				}
				// replace with the updated item
				const temp = {...group, ...group.group_member}
				temp.group_member = temp?.group_member?.filter(m => m.group_member_id !== action.payload.memberId)
				return {...group, ...temp}
			})

		default:
			return state
	}
}